<template>
  <div>
    <el-row class="mr-b4" type="flex" justify="end">
      <w-header-search-button @click="searchFlag = !searchFlag"></w-header-search-button>
    </el-row>
    <el-table-wrapper :data="configTableData" :columns="detailHistColumns" :column-default="columnDefault" ref="configTable"
     :show-custom-header="true" :show-search-tool="searchFlag" :pagination="true" @condition-change="setTableParameter">
       <template slot="detail-info" slot-scope="scope">
         <span @click="onClickDetailButton(scope.row)"><i class="far fa-search-plus c-pointer" /></span>
       </template>
    </el-table-wrapper>
    <w-detail-change-hist-popup ref="detailChangeHistPopup" :selectHistParams = "histChangparams"></w-detail-change-hist-popup>
    <w-dbms-change-hist-popup ref="dbmsChangeHistPopup" :selectHistParams = "histChangparams"></w-dbms-change-hist-popup>
    <w-vms-change-hist-popup ref="vmsChangeHistPopup" :selectHistParams = "histChangparams"></w-vms-change-hist-popup>
  </div>
</template>

<script>
import moment from 'moment';
import PerfApi from '@/api/performance/root';
import { columnDefault } from '@/constants/table';
import { isNil } from 'lodash';
import { convertValuByUnit } from '@/utils/number';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import WDetailChangeHistPopup from '@/views/config/node/components/DetailChangeHistPopup';
import WDbmsChangeHistPopup from '@/views/config/node/components/DbmsChangeHistPopup';
import WVmsChangeHistPopup from '@/views/config/node/components/VmsChangeHistPopup';

const endDatetime = moment();
endDatetime.hours(23);
endDatetime.minutes(59);
endDatetime.seconds(59);
const startDatetime = endDatetime.clone().subtract(7, 'days');
startDatetime.hours(0);
startDatetime.minutes(0);
startDatetime.seconds(0);

export default {
  name: 'WTimelineConfigInfo',
  components: {
    WDetailChangeHistPopup,
    WDbmsChangeHistPopup,
    WVmsChangeHistPopup,
  },
  props: {
    selectedEvent: {
      type: Object,
    },
  },
  data() {
    return {
      dateRange: [startDatetime.toDate(), endDatetime.toDate()],
      searchFlag: false,
      configTableData: [],
      columnDefault,
      detailHistColumns: [
        {
          prop: 'typeName',
          label: '변경타입',
          remoteProp: 'oct.type_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'chngGrpMessages',
          label: '변경 메시지',
          remoteProp: 'ocgh.chng_grp_message',
          sortable: true,
          searchable: true,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'checkDatetime',
          label: '변경 감지 시각',
          remoteProp: 'ocgh.check_datetime',
          sortable: true,
          formatter: this.getDateFormatter,
        },
        {
          width: 100,
          prop: 'detailHist',
          label: '상세보기',
          scopedSlot: 'detail-info',
          sortable: true,
        },
      ],
      limit: 50,
      start: 0,
      searchParams: null,
      histChangparams: {},
    };
  },
  methods: {
    loadData() {
      const timestamp = moment(this.selectedEvent.timestamp).toDate();
      const params = {
        timelineType: this.selectedEvent.timelineType,
        objIds: this.selectedEvent.objIds,
        start: this.start,
        limit: this.limit,
        timestamp,
        searchParams: this.searchParams,
      };
      PerfApi.getPerfTimelineInfo(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.configTableData = result.data;
        }
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value, 'YYYY-MM-DD hh:mm:ss');
      }
      return EMPTY_TEXT;
    },
    setTableParameter(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.loadData();
    },
    resetFilter() {
      this.searchFlag = false;
      this.$refs.configTable.clearFilter();
      this.limit = 50;
      this.start = 0;
      this.searchParams = null;
    },
    getConvertSizeByBData(row, column, value) {
      const typeKeyArr = this.numberArray;
      if (!isNil(typeKeyArr)) {
        const findKey = typeKeyArr.includes(row.typeKey);
        if (findKey) {
          return convertValuByUnit(value, 'Byte', true, true, true);
        }
      }
      return getValueAfterCheckEmpty(value);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 상세보기 클릭시 VMS, DBMS인 경우 DBMS detail 팝업 / 아닌 경우 일반 팝업
     * @author Song
     */
    onClickDetailButton(record) {
      this.histChangparams = {
        typeKey: record.typeKey,
        typeName: record.typeName,
        objId: record.objId,
        chngGrpSeqNumber: record.chngGrpSeqNumber,
        checkDatetime: record.checkDatetime,
        dateRange: this.dateRange,
        objtypeId: record.objtypeId,
        objDefineId: record.objDefineId,
      };
      if ((record.typeKey).indexOf('DB') > -1) {
        // DBMS 전용 팝업을 띄워야하는 경우
        this.$refs.dbmsChangeHistPopup.open();
      } else if (record.typeKey === 'VDMWARE' || record.typeKey === 'VD_CONFIG') {
        // VMS 전용
        this.$refs.vmsChangeHistPopup.open();
      } else {
        this.$refs.detailChangeHistPopup.open();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/popup/components/TimelineConfigInfo.vue